import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import annette from '@/assets/landing-before-after/annette.png'
import michael from '@/assets/landing-before-after/michael.png'
import jessica57 from '@/assets/landing-before-after/jessica-57.png'
import alicia from '@/assets/landing-before-after/alicia.png'
import jessica36 from '@/assets/landing-before-after/jessica-36.png'

const schema: LandingScreenSchema = {
	config: {
		background: 'base',
	},
	order: ['LandingBeforeAfter'],
	components: {
		LandingBeforeAfter: (): LandingComponentsConfig['LandingBeforeAfter'] => ({
			heading: 'Over 100,000 people have already changed how they feel in their body',
			beforeLabel: 'Before',
			afterLabel: 'After',
			trustpilotReviews: '42,501 reviews',
			ctaLabel: 'Continue',
			cards: [
				{ img: annette, name: 'Annette', lost: '−33.1 lbs', period: 'in 9 months' },
				{ img: michael, name: 'Michael', lost: '−58 lbs', period: 'in 9 months' },
				{ img: jessica57, name: 'Jessica', lost: '−57 lbs', period: 'in 9 months' },
				{ img: alicia, name: 'Alicia', lost: '−44 lbs', period: 'in 8 months' },
				{ img: jessica36, name: 'Jessica', lost: '−36 lbs', period: 'in 8 months' },
			],
		}),
	},
}

export default schema
